import React from 'react';

import { AtlassianIcon } from '@atlaskit/logo';

const Icon = (): React.JSX.Element => {
	return <AtlassianIcon appearance="brand" />;
};

export default Icon;
